import { createReducer } from '@reduxjs/toolkit'
import {
  setErrorMessage,
  updateArtisticStyle,
  updateIsTryAnotherTextVisible,
  updateQuery,
  updateRecommendation,
  updateSpace,
  setIsNotificationVisible,
  setResultCleared,
} from './actions'

const initialState = {
  query: null,
  artisticStyle: null,
  space: null,
  recommendation: null,
  isTryAnotherTextVisible: false,
  isNotificationVisible: false,
  errorMessage: null,
  isResultCleared: false,
}

export default createReducer(initialState, (builder) => {
  builder.addCase(updateQuery, (state, action) => {
    state.query = action.payload
  })
  builder.addCase(updateIsTryAnotherTextVisible, (state, action) => {
    state.isTryAnotherTextVisible = action.payload
  })
  builder.addCase(updateArtisticStyle, (state, action) => {
    state.artisticStyle = action.payload
  })
  builder.addCase(updateSpace, (state, action) => {
    state.space = action.payload
  })
  builder.addCase(updateRecommendation, (state, action) => {
    state.recommendation = action.payload
  })
  builder.addCase(setErrorMessage, (state, action) => {
    state.errorMessage = action.payload
  })
  builder.addCase(setIsNotificationVisible, (state, action) => {
    state.isNotificationVisible = action.payload
  })
  builder.addCase(setResultCleared, (state, action) => {
    state.isResultCleared = action.payload
  })
  builder.addDefaultCase((state, action) => {
    return state
  })
})

export function selectQuery(state) {
  return state.clientSetting.query
}

export function selectIsTryAnotherTextVisible(state) {
  return state.clientSetting.isTryAnotherTextVisible
}

export function selectArtisticStyle(state) {
  return state.clientSetting.artisticStyle
}

export function selectSpace(state) {
  return state.clientSetting.space
}

export function selectRecommendation(state) {
  return state.clientSetting.recommendation
}

export function selectErrorMessage(state) {
  return state.clientSetting.errorMessage
}

export function selectIsNotificationVisible(state) {
  return state.clientSetting.isNotificationVisible
}

export function selectIsResultCleared(state) {
  return state.clientSetting.isResultCleared
}
